<template>
  <div v-loading="loading" class="ec-line014">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <a :href="baseUrl">{{ this.shopName }}</a></el-breadcrumb-item
      >
      <el-breadcrumb-item :to="{ path: $routePage.EC_LINE009 }"> {{ $t('ec-line009.heading') }}</el-breadcrumb-item>
      <el-breadcrumb-item>{{ $t('ec-line014.title') }}</el-breadcrumb-item>
    </el-breadcrumb>
    <the-heading class="lg:mb-8 mb-5">{{ $t('ec-line014.title') }}</the-heading>
    <el-tabs v-if="subscriptionPaused.length" v-model="tab">
      <el-tab-pane :label="$t('ec-line009.tabs.subscriptionsNormal')" :name="Constants.EC_LINE009.TABS_TYPE.NORMAL">
        <div v-if="subscriptionNormal.length">
          <cart-subscription-item-list
            v-for="item in subscriptionNormalDisplay"
            :key="item.id"
            :data="item"
            :tab="tab"
            @to-detail="toDetailPage"
            @to-cpay="toCpayPage"
          ></cart-subscription-item-list>
          <el-pagination
            v-if="subscriptionNormal.length > normalSubscriptionPagination.record_limit"
            layout="prev, pager, next"
            :page-size="normalSubscriptionPagination.record_limit"
            :pager-count="3"
            :total="subscriptionNormal.length"
            :current-page="normalSubscriptionPagination.page"
            class="mt-10 pb-5 lg:pb-0 mx-auto"
            background
            @current-change="handleNormalSubsCurrentChange"
          ></el-pagination>
        </div>
        <p class="text-center" v-else>{{ $t('common.messages.noSubscriptionNormal') }}</p>
      </el-tab-pane>
      <el-tab-pane :label="$t('ec-line009.tabs.subscriptionsPaused')" :name="Constants.EC_LINE009.TABS_TYPE.PAUSED">
        <div v-if="subscriptionPaused.length">
          <cart-subscription-item-list
            v-for="item in subscriptionPauseDisplay"
            :key="item.id"
            :data="item"
            :tab="tab"
            @to-detail="toDetailPage"
            @to-cpay="toCpayPage"
          ></cart-subscription-item-list>
          <el-pagination
            v-if="subscriptionPaused.length > pausedSubscriptionPagination.record_limit"
            layout="prev, pager, next"
            :page-size="pausedSubscriptionPagination.record_limit"
            :pager-count="3"
            :total="subscriptionPaused.length"
            :current-page="pausedSubscriptionPagination.page"
            class="mt-10 pb-5 lg:pb-0 mx-auto"
            background
            @current-change="handlePausedSubsCurrentChange"
          ></el-pagination>
        </div>
        <p class="text-center" v-else>{{ $t('common.messages.noSubscription') }}</p>
      </el-tab-pane>
    </el-tabs>
    <div v-else-if="subscriptionNormal.length && !subscriptionPaused.length">
      <cart-subscription-item-list
        v-for="item in subscriptionNormalDisplay"
        :key="item.id"
        :data="item"
        :tab="tab"
        @to-detail="toDetailPage"
        @to-cpay="toCpayPage(item.code)"
      ></cart-subscription-item-list>
      <el-pagination
        v-if="subscriptionNormal.length > normalSubscriptionPagination.record_limit"
        layout="prev, pager, next"
        :page-size="normalSubscriptionPagination.record_limit"
        :pager-count="3"
        :total="subscriptionNormal.length"
        :current-page="normalSubscriptionPagination.page"
        class="mt-10 pb-5 lg:pb-0 mx-auto"
        background
        @current-change="handleNormalSubsCurrentChange"
      ></el-pagination>
    </div>
    <p class="text-center" v-else>{{ $t('common.messages.noSubscription') }}</p>

    <div class="w-full mt-5 lg:mt-10 pb-1 lg:pb-4 flex justify-center">
      <el-button class="cancel-btn align-center font-bold text-base lg:text-lg" @click="onCancel">
        {{ $t('common.action.cancel') }}
      </el-button>
    </div>
  </div>
</template>

<script>
import CartSubscriptionItemList from '@/components/ec-line014/CartSubscriptionItemList.vue'
import TheHeading from '@/components/my-page-partials/TheHeading.vue'
import { SubscriptionService, ProductService } from '@/services'
import BreadcrumbMixin from '@/mixins/breadcrumb'
import { REDIRECT_LINE015_FLAG } from '@/constants'
import deliveryNoteMixin from '@/mixins/deliveryNote'
import amazonMixin from '@/mixins/amazonV2'
import { AMAZON } from '@/constants/amazon'

export default {
  components: { CartSubscriptionItemList, TheHeading },
  mixins: [BreadcrumbMixin, deliveryNoteMixin, amazonMixin],
  data() {
    return {
      loading: false,
      items: [],
      tab: this.Constants.EC_LINE009.TABS_TYPE.NORMAL,
      normalSubscriptionPagination: {
        page: 1,
        record_limit: 10,
      },
      pausedSubscriptionPagination: {
        page: 1,
        record_limit: 10,
      },
    }
  },
  computed: {
    user() {
      return this.$store.getters['auth/user']
    },
    subscriptionNormal() {
      return this.items.filter((item) => item.subscription_status_id !== this.Constants.SUBSCRIPTION_STATUS.PAUSE)
    },
    subscriptionPaused() {
      return this.items.filter((item) => item.subscription_status_id === this.Constants.SUBSCRIPTION_STATUS.PAUSE)
    },
    subscriptionNormalDisplay() {
      const pagination = this.normalSubscriptionPagination
      const startNum = (pagination.page - 1) * pagination.record_limit
      const endNum = pagination.page * pagination.record_limit
      return this.subscriptionNormal.slice(startNum, endNum)
    },
    subscriptionPauseDisplay() {
      const pagination = this.pausedSubscriptionPagination
      const startNum = (pagination.page - 1) * pagination.record_limit
      const endNum = pagination.page * pagination.record_limit
      return this.subscriptionPaused.slice(startNum, endNum)
    },
  },
  watch: {
    tab(val) {
      this.$store.commit('subscription/SET_SUB_LIST_TYPE', val)
    },
  },

  created() {
    this.tab = this.$store.getters['subscription/getSubListType']

    // clear subscription
    this.$store.commit('subscription/UPDATE_SUBSCRIPTION')
    this.$store.commit('subscription/SET_SUBSCRIPTION_CONFIRM')
    this.fetchData()
    this.logoutAmazon()
  },
  beforeDestroy() {
    this.$store.commit('subscription/SET_SUB_LIST_TYPE', this.tab)
  },
  methods: {
    async fetchData() {
      try {
        this.loading = true
        const subscriptionStatusList = Object.values(this.Constants.SUBSCRIPTION_STATUS).filter((item) => {
          return item !== this.Constants.SUBSCRIPTION_STATUS.CANCEL
        })
        const subscription_status = subscriptionStatusList.join(',')
        const params = {
          subscription_status,
          page: 1,
          record_limit: 100,
        }

        const { data } = await SubscriptionService.getSubscriptions(params)

        const { pagination, items } = data
        let subscriptions = items
          .filter((item) => item.subscription_status_id !== this.Constants.SUBSCRIPTION_STATUS.CANCEL)
          .map((item) => Object.assign({ ...item, index: item.subscription_no }))

        for (let subscription of subscriptions) {
          const product_sku_ids = subscription.subscription_order_item
            .map((i) => i.product_sku_id + ':' + i.quantity)
            .join()

          if (product_sku_ids) {
            let params = {
              is_subscription: 1,
              product_sku_ids,
              customer_id: this.user && this.user.id,
              subscription_id: subscription.id,
              delivery_fee: subscription.delivery_fee,
            }

            if (subscription.adjustment_amount !== null) {
              params = {
                ...params,
                adjustment_amount: subscription.adjustment_amount,
              }
            }

            const { data } = await ProductService.getProductSku(params)

            subscription.summary = data.summary
            for (let order of subscription.subscription_order_item) {
              for (let sku of data.items) {
                if (order.product_code === sku.product_code) {
                  order.sku = sku
                }
              }
            }
          }
        }

        this.pagination = pagination
        this.items = subscriptions
        if (!this.subscriptionNormal.length && this.subscriptionPaused.length) {
          this.tab = this.Constants.EC_LINE009.TABS_TYPE.PAUSED
        }
      } finally {
        this.loading = false
      }
    },
    toCpayPage(code) {
      this.$router.push({
        path: '/lpc/cpay',
        query: {
          code,
        },
      })
    },

    toDetailPage(payload) {
      const subscriptionNo = payload.index
      this.$store.commit('subscription/SET_SUBSCRIPTION_NO', subscriptionNo)
      if (payload.redirectReason === REDIRECT_LINE015_FLAG.REDIRECT) {
        this.$router.push({
          name: 'EC_LINE015',
          params: { id: payload.id },
          query: {
            section: payload.section,
            subscriptionNo,
          },
        })
      } else {
        this.loading = true

        SubscriptionService.getSubscriptionDetail(payload.id)
          .then(({ data }) => {
            const { subscription_order_item } = data

            if (subscription_order_item) {
              const idx = subscription_order_item.findIndex((i) => i.id === payload.order_item_id)
              if (idx !== -1) {
                const order_item = Object.assign({ ...subscription_order_item[idx] })
                order_item.quantity = Math.min(999, Number(order_item.quantity) + 1)
                data.subscription_order_item.splice(idx, 1, order_item)
              }
            }
            this.$store.commit('subscription/UPDATE_SUBSCRIPTION', data)

            this.$router.push({
              name: 'EC_LINE015',
              params: { id: payload.id },
              query: {
                subscriptionNo,
              },
            })
          })
          .finally(() => (this.loading = false))
      }
    },
    onCancel() {
      this.$router.push({
        path: this.$routePage.EC_LINE009,
      })
    },
    handleNormalSubsCurrentChange(page) {
      this.normalSubscriptionPagination.page = page
    },
    handlePausedSubsCurrentChange(page) {
      this.pausedSubscriptionPagination.page = page
    },
    logoutAmazon() {
      if (this.isLoginAmazon) {
        this.onAmazonLogout(AMAZON.ACCESS_TOKEN_015)
      }
    },
  },
  metaInfo() {
    return {
      title: this.$t('ec-line014.title'),
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: this.$t('ec-line014.description', { shop_name: this.shopName }),
        },
        {
          vmid: 'keywords',
          name: 'keywords',
          content: this.$t('ec-line014.keyword', { shop_name: this.shopName }),
        },
      ],
    }
  },
}
</script>

<style lang="scss">
@import '@/assets/css/pages/ec-line014.scss';
</style>
